var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100%","border":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }